export const ASCENDANT_ORDER = "ASCENDANT_ORDER"
export const DESCENDANT_ORDER = "DESCENDANT_ORDER"
export const MONTHLY = "monthly"
export const YEARLY = "yearly"